// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"c29139d9","434":"87dffce3","781":"0e4b734d"}[chunkId] + ".chunk.css";
};